import { useMemo } from 'react';
import { ThemeProvider, createNewTheme, useTheme } from 'material-hu';

const useNewTheme = () => {
  const theme = useTheme();

  return useMemo(() => {
    const newTheme = createNewTheme({
      colorPreset: theme.palette.primary.main,
    });

    const newThemeComponent = ({ children }) => (
      <ThemeProvider theme={newTheme}>{children}</ThemeProvider>
    );

    return newThemeComponent;
  }, []);
};

export default useNewTheme;
